import { Component, OnInit, DoCheck, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UtilService } from '../services/util.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { APP_MODEL_DATA } from '../model-data/app-model-data';
import { MainService } from '../services/main.service';
import { confirmPasswordValidator, newPasswordValidator } from '../custom-validation';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { CustomPopupComponent } from '../custom-popup/custom-popup.component';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    standalone: false
})

export class ResetPasswordComponent implements OnInit, DoCheck, OnDestroy {
  resetPasswordForm: FormGroup = new FormGroup({});
  resetCode:string = "";
  userName:string = "";
  env:string = "";
  successErrorModal: any;
  newPasswordInputType: string = APP_MODEL_DATA.INPUT_TYPE_PASSWORD;
  confirmPasswordInputType: string = APP_MODEL_DATA.INPUT_TYPE_PASSWORD;
  hideResetPasswordForm: boolean = false;
  showResetPasswordForm: boolean = false;
  showSuccessMessage: boolean = false;   
  isPasswordfieldFocused: boolean = false;
  isConfirmPasswordfieldFocused: boolean = false;
  modalRef?: BsModalRef;
  private langSubscription?: Subscription;

  constructor(public utilService: UtilService, public mainService: MainService,
    public formBuilder: FormBuilder, private myTitle: Title, private modalService: BsModalService,
    private translateService: TranslateService, private router: Router ) { 
    //this.utilService.showNavigationBar.next(false);
    this.utilService.hideHeader.next(true);
  }

  ngOnInit(): void {
    const params = this.utilService.getUrlParams();
    if(params["code"])
    {
      this.resetCode = params["code"];
    }
    if(params["username"])
    {
      this.userName = params["username"];
    }
    if(params["env"])
    {
      this.env = params["env"]?.toLowerCase() ?? '';
    }

    this.initializeResetPasswordForm();

    if (this.utilService.getToken('idToken')) {
      this.showAlreadyLoggedInPopup();
      return;
    }

    this.showResetPasswordForm = true;
  }

  private initializeResetPasswordForm(): void {
    this.resetPasswordForm = this.formBuilder.group({
      resetCode: [this.resetCode,  [Validators.required]],
      userName: [this.userName,[Validators.required]],
      newPassword: ['',[Validators.required, newPasswordValidator()]],
      confirmPassword:['',[Validators.required]]
      },
      {
        validators: [confirmPasswordValidator()]
    });
  }

  private showAlreadyLoggedInPopup(): void {
    this.showResetPasswordForm = false;
    this.modalRef = this.modalService.show(CustomPopupComponent);

    const modalInstance = this.modalRef.content;
    modalInstance.title = 'Already Logged In';
    modalInstance.description = 'You are already logged in. Sign out to continue resetting your password.';
    modalInstance.buttons = [
      { title: '', actionId: 'cancel', isActive: false, styleClass: 'cancel-label' },
      { title: '', actionId: 'signout', isActive: true, styleClass: 'confirm-label' }
    ];

    this.langSubscription = this.translateService.get(['lang.close', 'lang.sign_out']).subscribe(translations => {
      modalInstance.buttons = [
        { title: translations['lang.sign_out'], actionId: 'signout', isActive: true, styleClass: 'confirm-label' }
      ];
    });

    modalInstance.buttonClicked.subscribe((actionId: string) => {
      if (actionId === 'signout') {
        this.utilService.clearStorage();
        this.showResetPasswordForm = true;
      } 

      this.modalRef?.hide();
    });
  }

  ngOnDestroy(): void {
    this.langSubscription?.unsubscribe();
  }

  get resetPasswordFormControl(): { [key: string]: AbstractControl } {
    return this.resetPasswordForm.controls;
  }

  resetPassword() {
    const isProd = this.env === "prod" ? true : false;

    if(this.showResetPasswordForm && this.resetPasswordForm.valid){
      this.mainService.resetPassword(this.resetPasswordForm.value, isProd).subscribe((response:any) => {
        this.hideResetPasswordForm = true;
        this.showSuccessMessage = true;
      });
    }
  }

  showHidePasswordText() {
    this.newPasswordInputType = (this.newPasswordInputType == APP_MODEL_DATA.INPUT_TYPE_PASSWORD) ? APP_MODEL_DATA.INPUT_TYPE_TEXT : APP_MODEL_DATA.INPUT_TYPE_PASSWORD;
    this.confirmPasswordInputType = (this.confirmPasswordInputType == APP_MODEL_DATA.INPUT_TYPE_PASSWORD) ? APP_MODEL_DATA.INPUT_TYPE_TEXT : APP_MODEL_DATA.INPUT_TYPE_PASSWORD;
  }

  //we need a title here not in NgOnInit hook because otherwise it is overwritten by app.module.ts (translation event)
  ngDoCheck(): void {
    this.myTitle.setTitle ("Password Reset - Fluidra Pool")
  }
}
